<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-6">
            <label>Zeitraum</label>
            <div class="form-group has-label">
              <el-date-picker v-model="dateRange" type="daterange" range-separator="Bis"
                start-placeholder="Anfangsdatum" end-placeholder="Enddatum" format="dd.MM.yyyy"
                value-format="yyyy-MM-dd" @change="filterData" :picker-options="{ firstDayOfWeek: 1 }" />
            </div>
            <product-select v-model="product" @input="filterData" />
            <div class="row">
              <div class="col-sm-6" v-if="warehouses.length > 1">
                <label>Lager</label>
                <div class="form-group has-label">
                  <multiselect v-model="warehouse" :options="warehouses" track-by="id" label="short_name"
                    @input="filterData" />
                </div>
              </div>
              <div class="col-sm-6">
                <label>Grund</label>
                <div class="form-group has-label">
                  <multiselect v-model="cause" :options="causes" track-by="id" label="name" @input="filterData" />
                </div>
              </div>
            </div>
            <div class="row" v-if="costCenters.length > 1">
              <div class="col-sm-6">
                <label>Kostenstelle</label>
                <div class="form-group has-label">
                  <multiselect v-model="costCenter" :options="costCenters" track-by="id" label="name"
                    @input="filterData" />
                </div>
              </div>
              <div class="col-sm-6">
                <label>Produktkategorien</label>
                <div class="form-group has-label">
                  <multiselect v-model="productCategory" :options="productCategories" track-by="id" label="name"
                    @input="filterData" />
                </div>
              </div>
              <div class="col-sm-6">
                <label>Lieferant</label>
                <div class="form-group has-label">
                  <multiselect v-model="supplier" :options="suppliers" track-by="id" label="name" @input="filterData" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="overflow-x: auto; margin-top: 0.75em;">
          <table class="table table-striped table-bordered">
            <thead>

              <tr>
                <th>Produkt</th>
                <th>Menge</th>
                <th>Einbuchungen</th>
                <th>Ausbuchungen</th>
                <th>Einkaufspreis</th>
                <th>Gesamteinkaufspreis</th>
                <th v-if="warehouses.length > 1">Lager</th>
                <th>Produktkategorie</th>
              </tr>
            </thead>
            <transition name="el-fade-in-linear">
              <tbody v-if="!loading">
                <tr is="StockRotationRow" v-for="stockRotation in stockRotations" :key="stockRotation.id"
                  :stock-rotation="stockRotation" :accumulated="true" :show-warehouse="warehouses.length > 1" />
              </tbody>
            </transition>

            <tr
              v-if="stockRotationsSum && stockRotationsSum[0].sum_quantity_in && stockRotationsSum[0].sum_quantity_out">
              <th class="text-left" style="font-size: .9rem; position: relative;"><strong>Summe:</strong></th>
              <th class="text-right" style="font-size: .9rem; position: relative;"><strong>{{
                stockRotationsSum[0].sum_quantity }}</strong></th>
              <th class="text-right" style="font-size: .9rem; position: relative; ">
                <span class="rotation-in">{{ stockRotationsSum[0].sum_quantity_in }}</span>
              </th>
              <th class="text-right" style="font-size: .9rem; position: relative; ">
                <span class="rotation-out">{{ stockRotationsSum[0].sum_quantity_out }}</span>
              </th>
              <th class="text-right" style="font-size: .9rem; position: relative; ">
                <span class="rotation-out">{{ totalEinkaufsPreis | priceFromCentEuro }}</span>
              </th>
              <th class="text-right" style="font-size: .9rem; position: relative; ">
                <span class="rotation-out">{{ stockRotationsSum[0].totalEinkauf | priceFromCentEuro }}</span>
              </th>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <l-pagination background layout="prev, pager, next" :per-page="10" :page-count="pageCount" :value="currentPage"
      @input="changePage" @changePerPage="changePerPage" />
  </div>
</template>

<script>
import StockRotationRow from 'src/pages/StockRotations/stock-rotation-row'
import hasPagination from 'src/has-pagination'
import { DatePicker } from 'element-ui'
import moment from 'moment'
import ProductSelect from 'src/components/product-select'

export default {
  components: {
    StockRotationRow,
    ProductSelect,
    [DatePicker.name]: DatePicker
  },
  mixins: [hasPagination],
  data() {
    return {
      dateRange: [
        moment().subtract(1, 'years').startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD')
      ],
      stockRotations: [],
      loading: true,
      warehouses: [],
      causes: [],
      costCenters: [],
      warehouse: null,
      product: null,
      cause: null,
      costCenter: null,
      suppliers: [],
      supplier: null,
      stockRotationsSum: null,
      stockRotationsFull: null,
      totalEinkaufsPreis: 0,
      productCategory: null,
      productCategories: []

    }
  },
  methods: {
    filterData() {
      this.loading = true
      this.changePage(1)
      this.getSum()
    },
    getSum() {
      var query = this.getQuery()
      this.$http.get(`/stock_rotations/sum?${query}`).then(({ data }) => {
        this.stockRotationsSum = data
        console.log(data)
      })

      const QueryWithoutPagination = query.replace('per_page=50&', '').replace('paginate=1', '')
      this.$http.get(`/stock_rotations?${QueryWithoutPagination}`).then(({ data }) => {

        this.totalEinkaufsPreis = 0
        data.forEach(element => {
          this.totalEinkaufsPreis += element.einkaufspreis
        })
      })
    },

    getCustomQueryData() {
      return {
        date_range: this.dateRange ? encodeURIComponent(this.dateRange) : '',
        accumulated: 1,
        product: this.product ? this.product.id : '',
        warehouse: this.warehouse ? this.warehouse.id : '',
        cause: this.cause ? this.cause.id : '',
        cost_center: this.costCenter ? this.costCenter.id : '',
        supplier: this.supplier ? this.supplier.id : '',
        product_category: this.productCategory ? this.productCategory.id : ''
      }
    },
    getData(query) {
      return this.$http.get(`/stock_rotations?${query}`).then(({ data }) => {
        this.stockRotations = data.data
        this.pageCount = data.last_page
        this.loading = false
      })
    },
    // @override
    changePage(page) {
      if (this.currentPage !== page) {
        this.$router.push(`/stats/rotations?page=${page}`)
      } else {
        this.fetchTableData()
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query && to.query.page) {
      this.currentPage = +to.query.page
      this.fetchTableData().then(() => { next() })
    } else {
      this.currentPage = 1
      this.fetchTableData().then(() => { next() })
    }
  },
  created() {
    if (this.$route.query && this.$route.query.page) {
      this.currentPage = +this.$route.query.page
    }

    this.fetchTableData()
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
    this.$http.get(`/causes`).then(({ data }) => {
      this.causes = data
    })
    this.$http.get(`/cost_centers`).then(({ data }) => {
      this.costCenters = data
    })
    this.$http.get(`/suppliers`).then(({ data }) => {
      this.suppliers = data
    })
    this.$http.get(`/product_categories`).then(({ data }) => {
      this.productCategories = data
    })
    this.getSum()
  }
}
</script>

<style></style>
